import DealAnalytics from '@/components/DealAnalytics';

const DealAnalyticsPage = () => {
  return <DealAnalytics />;
};

export default DealAnalyticsPage;
